import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import ArgonDashboard from "./argon-dashboard";
import VueMask from '@devindex/vue-mask';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.use(VueMask); 
appInstance.mount("#app");
